import { register } from '~/core/repository'
import { model as paymentModel } from '~/features/payment'
import { $payment } from './l10n'

/* Common stores and events */
register(paymentModel.$isAnyPaymentPopupOpened, '$isAnyPaymentPopupOpened')

register($payment, '$payment')
